import { render, staticRenderFns } from "./GlobalGet.vue?vue&type=template&id=3eef1900&scoped=true"
import script from "./GlobalGet.vue?vue&type=script&lang=js"
export * from "./GlobalGet.vue?vue&type=script&lang=js"
import style0 from "./GlobalGet.vue?vue&type=style&index=0&id=3eef1900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eef1900",
  null
  
)

export default component.exports